export default "__VITE_ASSET__a0f34a69__"